// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddTicketMessageData, AddTicketMessageErrors, AddTicketMessageResponses, CancelAccountDeletionData, CancelAccountDeletionErrors, CancelAccountDeletionResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ConfirmEmailData, ConfirmEmailErrors, ConfirmEmailResponses, ConfirmMfaEnrollmentData, ConfirmMfaEnrollmentErrors, ConfirmMfaEnrollmentResponses, ContributeTaxonData, ContributeTaxonErrors, ContributeTaxonResponses, CreateTicketData, CreateTicketErrors, CreateTicketResponses, DeleteCollectionData, DeleteCollectionErrors, DeleteCollectionResponses, DeletePlantCareScheduleData, DeletePlantCareScheduleErrors, DeletePlantCareScheduleResponses, DeletePlantData, DeletePlantErrors, DeletePlantJournalEntryData, DeletePlantJournalEntryErrors, DeletePlantJournalEntryResponses, DeletePlantPhotoData, DeletePlantPhotoErrors, DeletePlantPhotoResponses, DeletePlantResponses, DeleteUploadData, DeleteUploadErrors, DeleteUploadResponses, DisableMfaData, DisableMfaErrors, DisableMfaResponses, EnrollMfaData, EnrollMfaErrors, EnrollMfaResponses, ExportAccountData, ExportAccountErrors, ExportAccountResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetAccountDeletionData, GetAccountDeletionErrors, GetAccountDeletionResponses, GetCollectionData, GetCollectionErrors, GetCollectionResponses, GetHealthData, GetHealthErrors, GetHealthResponses, GetMeData, GetMeErrors, GetMeResponses, GetPlantCareScheduleData, GetPlantCareScheduleErrors, GetPlantCareScheduleResponses, GetPlantData, GetPlantErrors, GetPlantJournalEntryData, GetPlantJournalEntryErrors, GetPlantJournalEntryResponses, GetPlantPhotoData, GetPlantPhotoErrors, GetPlantPhotoResponses, GetPlantResponses, GetPlanUsageData, GetPlanUsageErrors, GetPlanUsageResponses, GetSharedCollectionData, GetSharedCollectionErrors, GetSharedCollectionResponses, GetTaxonLineageData, GetTaxonLineageErrors, GetTaxonLineageResponses, GetTicketData, GetTicketErrors, GetTicketResponses, GetUploadUrlData, GetUploadUrlErrors, GetUploadUrlResponses, ListCollectionsData, ListCollectionsErrors, ListCollectionsResponses, ListPlantCareSchedulesData, ListPlantCareSchedulesErrors, ListPlantCareSchedulesResponses, ListPlantJournalEntriesData, ListPlantJournalEntriesErrors, ListPlantJournalEntriesResponses, ListPlantPhotosData, ListPlantPhotosErrors, ListPlantPhotosResponses, ListPlantsData, ListPlantsErrors, ListPlantsResponses, ListTicketsData, ListTicketsErrors, ListTicketsResponses, PatchCollectionData, PatchCollectionErrors, PatchCollectionResponses, PatchPlantCareScheduleData, PatchPlantCareScheduleErrors, PatchPlantCareScheduleResponses, PatchPlantData, PatchPlantErrors, PatchPlantJournalEntryData, PatchPlantJournalEntryErrors, PatchPlantJournalEntryResponses, PatchPlantPhotoData, PatchPlantPhotoErrors, PatchPlantPhotoResponses, PatchPlantResponses, PutCollectionData, PutCollectionErrors, PutCollectionResponses, PutPlantCareScheduleData, PutPlantCareScheduleErrors, PutPlantCareScheduleResponses, PutPlantData, PutPlantErrors, PutPlantJournalEntryData, PutPlantJournalEntryErrors, PutPlantJournalEntryResponses, PutPlantPhotoData, PutPlantPhotoErrors, PutPlantPhotoResponses, PutPlantResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RegisterDevicePushTokenData, RegisterDevicePushTokenErrors, RegisterDevicePushTokenResponses, RequestAccountDeletionData, RequestAccountDeletionErrors, RequestAccountDeletionResponses, RequestMagicLinkData, RequestMagicLinkErrors, RequestMagicLinkResponses, ResendConfirmationData, ResendConfirmationErrors, ResendConfirmationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RevenueCatWebhookData, RevenueCatWebhookErrors, RevenueCatWebhookResponses, SearchTaxaData, SearchTaxaErrors, SearchTaxaResponses, SetTicketStatusData, SetTicketStatusErrors, SetTicketStatusResponses, ShareCollectionData, ShareCollectionErrors, ShareCollectionResponses, SignInData, SignInErrors, SignInResponses, SignOutData, SignOutErrors, SignOutResponses, SignUpData, SignUpErrors, SignUpResponses, SubmitContactData, SubmitContactErrors, SubmitContactResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, UpdateMeData, UpdateMeErrors, UpdateMeResponses, VerifyMagicLinkData, VerifyMagicLinkErrors, VerifyMagicLinkResponses, VerifyMfaData, VerifyMfaErrors, VerifyMfaResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Cancel a scheduled deletion
 */
export const cancelAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<CancelAccountDeletionData, ThrowOnError>): RequestResult<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).delete<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Current deletion request, if any
 */
export const getAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<GetAccountDeletionData, ThrowOnError>): RequestResult<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).get<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Schedule the account for deletion
 */
export const requestAccountDeletion = <ThrowOnError extends boolean = false>(options: Options<RequestAccountDeletionData, ThrowOnError>): RequestResult<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError> => (options.client ?? client).post<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export all of the user's data
 */
export const exportAccount = <ThrowOnError extends boolean = false>(options?: Options<ExportAccountData, ThrowOnError>): RequestResult<ExportAccountResponses, ExportAccountErrors, ThrowOnError> => (options?.client ?? client).get<ExportAccountResponses, ExportAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/export',
    ...options
});

/**
 * Confirm an email address
 */
export const confirmEmail = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailData, ThrowOnError>): RequestResult<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError> => (options.client ?? client).post<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError>({
    url: '/v1/auth/email/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend the confirmation email
 */
export const resendConfirmation = <ThrowOnError extends boolean = false>(options: Options<ResendConfirmationData, ThrowOnError>): RequestResult<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError> => (options.client ?? client).post<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError>({
    url: '/v1/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signed-in user
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options
});

/**
 * Update the signed-in user
 */
export const updateMe = <ThrowOnError extends boolean = false>(options: Options<UpdateMeData, ThrowOnError>): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn off two-factor authentication (needs an MFA-verified session)
 */
export const disableMfa = <ThrowOnError extends boolean = false>(options?: Options<DisableMfaData, ThrowOnError>): RequestResult<DisableMfaResponses, DisableMfaErrors, ThrowOnError> => (options?.client ?? client).post<DisableMfaResponses, DisableMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/disable',
    ...options
});

/**
 * Begin two-factor enrolment
 */
export const enrollMfa = <ThrowOnError extends boolean = false>(options?: Options<EnrollMfaData, ThrowOnError>): RequestResult<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError> => (options?.client ?? client).post<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll',
    ...options
});

/**
 * Confirm enrolment with a code
 */
export const confirmMfaEnrollment = <ThrowOnError extends boolean = false>(options: Options<ConfirmMfaEnrollmentData, ThrowOnError>): RequestResult<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish a two-factor sign-in
 */
export const verifyMfa = <ThrowOnError extends boolean = false>(options: Options<VerifyMfaData, ThrowOnError>): RequestResult<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError> => (options.client ?? client).post<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError>({
    url: '/v1/auth/mfa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a sign-in link
 */
export const requestMagicLink = <ThrowOnError extends boolean = false>(options: Options<RequestMagicLinkData, ThrowOnError>): RequestResult<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with an emailed token
 */
export const verifyMagicLink = <ThrowOnError extends boolean = false>(options: Options<VerifyMagicLinkData, ThrowOnError>): RequestResult<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change password
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/password/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a password reset link
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a new password using an emailed token
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate the refresh token
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 */
export const signIn = <ThrowOnError extends boolean = false>(options: Options<SignInData, ThrowOnError>): RequestResult<SignInResponses, SignInErrors, ThrowOnError> => (options.client ?? client).post<SignInResponses, SignInErrors, ThrowOnError>({
    url: '/v1/auth/sign-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke the current session
 */
export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError> => (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/sign-out',
    ...options
});

/**
 * Create an account
 */
export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>): RequestResult<SignUpResponses, SignUpErrors, ThrowOnError> => (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    url: '/v1/auth/sign-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a share link for a collection
 */
export const shareCollection = <ThrowOnError extends boolean = false>(options: Options<ShareCollectionData, ThrowOnError>): RequestResult<ShareCollectionResponses, ShareCollectionErrors, ThrowOnError> => (options.client ?? client).post<ShareCollectionResponses, ShareCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/collection-shares',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Collection rows (delta sync)
 */
export const listCollections = <ThrowOnError extends boolean = false>(options?: Options<ListCollectionsData, ThrowOnError>): RequestResult<ListCollectionsResponses, ListCollectionsErrors, ThrowOnError> => (options?.client ?? client).get<ListCollectionsResponses, ListCollectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/collections',
    ...options
});

/**
 * Delete a Collection (soft by default)
 */
export const deleteCollection = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectionData, ThrowOnError>): RequestResult<DeleteCollectionResponses, DeleteCollectionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectionResponses, DeleteCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/collections/{id}',
    ...options
});

/**
 * Get one Collection
 */
export const getCollection = <ThrowOnError extends boolean = false>(options: Options<GetCollectionData, ThrowOnError>): RequestResult<GetCollectionResponses, GetCollectionErrors, ThrowOnError> => (options.client ?? client).get<GetCollectionResponses, GetCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/collections/{id}',
    ...options
});

/**
 * Update fields of a Collection
 */
export const patchCollection = <ThrowOnError extends boolean = false>(options: Options<PatchCollectionData, ThrowOnError>): RequestResult<PatchCollectionResponses, PatchCollectionErrors, ThrowOnError> => (options.client ?? client).patch<PatchCollectionResponses, PatchCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/collections/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a Collection (idempotent)
 */
export const putCollection = <ThrowOnError extends boolean = false>(options: Options<PutCollectionData, ThrowOnError>): RequestResult<PutCollectionResponses, PutCollectionErrors, ThrowOnError> => (options.client ?? client).put<PutCollectionResponses, PutCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/collections/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a contact message
 */
export const submitContact = <ThrowOnError extends boolean = false>(options: Options<SubmitContactData, ThrowOnError>): RequestResult<SubmitContactResponses, SubmitContactErrors, ThrowOnError> => (options.client ?? client).post<SubmitContactResponses, SubmitContactErrors, ThrowOnError>({
    url: '/v1/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register this device for push notifications
 */
export const registerDevicePushToken = <ThrowOnError extends boolean = false>(options: Options<RegisterDevicePushTokenData, ThrowOnError>): RequestResult<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError> => (options.client ?? client).put<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/device-push-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send feedback
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    url: '/v1/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liveness and database check
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, GetHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({ url: '/v1/health', ...options });

/**
 * Plan limits and usage
 */
export const getPlanUsage = <ThrowOnError extends boolean = false>(options?: Options<GetPlanUsageData, ThrowOnError>): RequestResult<GetPlanUsageResponses, GetPlanUsageErrors, ThrowOnError> => (options?.client ?? client).get<GetPlanUsageResponses, GetPlanUsageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plan',
    ...options
});

/**
 * List PlantCareSchedule rows (delta sync)
 */
export const listPlantCareSchedules = <ThrowOnError extends boolean = false>(options?: Options<ListPlantCareSchedulesData, ThrowOnError>): RequestResult<ListPlantCareSchedulesResponses, ListPlantCareSchedulesErrors, ThrowOnError> => (options?.client ?? client).get<ListPlantCareSchedulesResponses, ListPlantCareSchedulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-care-schedules',
    ...options
});

/**
 * Delete a PlantCareSchedule (soft by default)
 */
export const deletePlantCareSchedule = <ThrowOnError extends boolean = false>(options: Options<DeletePlantCareScheduleData, ThrowOnError>): RequestResult<DeletePlantCareScheduleResponses, DeletePlantCareScheduleErrors, ThrowOnError> => (options.client ?? client).delete<DeletePlantCareScheduleResponses, DeletePlantCareScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-care-schedules/{id}',
    ...options
});

/**
 * Get one PlantCareSchedule
 */
export const getPlantCareSchedule = <ThrowOnError extends boolean = false>(options: Options<GetPlantCareScheduleData, ThrowOnError>): RequestResult<GetPlantCareScheduleResponses, GetPlantCareScheduleErrors, ThrowOnError> => (options.client ?? client).get<GetPlantCareScheduleResponses, GetPlantCareScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-care-schedules/{id}',
    ...options
});

/**
 * Update fields of a PlantCareSchedule
 */
export const patchPlantCareSchedule = <ThrowOnError extends boolean = false>(options: Options<PatchPlantCareScheduleData, ThrowOnError>): RequestResult<PatchPlantCareScheduleResponses, PatchPlantCareScheduleErrors, ThrowOnError> => (options.client ?? client).patch<PatchPlantCareScheduleResponses, PatchPlantCareScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-care-schedules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a PlantCareSchedule (idempotent)
 */
export const putPlantCareSchedule = <ThrowOnError extends boolean = false>(options: Options<PutPlantCareScheduleData, ThrowOnError>): RequestResult<PutPlantCareScheduleResponses, PutPlantCareScheduleErrors, ThrowOnError> => (options.client ?? client).put<PutPlantCareScheduleResponses, PutPlantCareScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-care-schedules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List PlantJournalEntry rows (delta sync)
 */
export const listPlantJournalEntries = <ThrowOnError extends boolean = false>(options?: Options<ListPlantJournalEntriesData, ThrowOnError>): RequestResult<ListPlantJournalEntriesResponses, ListPlantJournalEntriesErrors, ThrowOnError> => (options?.client ?? client).get<ListPlantJournalEntriesResponses, ListPlantJournalEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-journal-entries',
    ...options
});

/**
 * Delete a PlantJournalEntry (soft by default)
 */
export const deletePlantJournalEntry = <ThrowOnError extends boolean = false>(options: Options<DeletePlantJournalEntryData, ThrowOnError>): RequestResult<DeletePlantJournalEntryResponses, DeletePlantJournalEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeletePlantJournalEntryResponses, DeletePlantJournalEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-journal-entries/{id}',
    ...options
});

/**
 * Get one PlantJournalEntry
 */
export const getPlantJournalEntry = <ThrowOnError extends boolean = false>(options: Options<GetPlantJournalEntryData, ThrowOnError>): RequestResult<GetPlantJournalEntryResponses, GetPlantJournalEntryErrors, ThrowOnError> => (options.client ?? client).get<GetPlantJournalEntryResponses, GetPlantJournalEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-journal-entries/{id}',
    ...options
});

/**
 * Update fields of a PlantJournalEntry
 */
export const patchPlantJournalEntry = <ThrowOnError extends boolean = false>(options: Options<PatchPlantJournalEntryData, ThrowOnError>): RequestResult<PatchPlantJournalEntryResponses, PatchPlantJournalEntryErrors, ThrowOnError> => (options.client ?? client).patch<PatchPlantJournalEntryResponses, PatchPlantJournalEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-journal-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a PlantJournalEntry (idempotent)
 */
export const putPlantJournalEntry = <ThrowOnError extends boolean = false>(options: Options<PutPlantJournalEntryData, ThrowOnError>): RequestResult<PutPlantJournalEntryResponses, PutPlantJournalEntryErrors, ThrowOnError> => (options.client ?? client).put<PutPlantJournalEntryResponses, PutPlantJournalEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-journal-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List PlantPhoto rows (delta sync)
 */
export const listPlantPhotos = <ThrowOnError extends boolean = false>(options?: Options<ListPlantPhotosData, ThrowOnError>): RequestResult<ListPlantPhotosResponses, ListPlantPhotosErrors, ThrowOnError> => (options?.client ?? client).get<ListPlantPhotosResponses, ListPlantPhotosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-photos',
    ...options
});

/**
 * Delete a PlantPhoto (soft by default)
 */
export const deletePlantPhoto = <ThrowOnError extends boolean = false>(options: Options<DeletePlantPhotoData, ThrowOnError>): RequestResult<DeletePlantPhotoResponses, DeletePlantPhotoErrors, ThrowOnError> => (options.client ?? client).delete<DeletePlantPhotoResponses, DeletePlantPhotoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-photos/{id}',
    ...options
});

/**
 * Get one PlantPhoto
 */
export const getPlantPhoto = <ThrowOnError extends boolean = false>(options: Options<GetPlantPhotoData, ThrowOnError>): RequestResult<GetPlantPhotoResponses, GetPlantPhotoErrors, ThrowOnError> => (options.client ?? client).get<GetPlantPhotoResponses, GetPlantPhotoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-photos/{id}',
    ...options
});

/**
 * Update fields of a PlantPhoto
 */
export const patchPlantPhoto = <ThrowOnError extends boolean = false>(options: Options<PatchPlantPhotoData, ThrowOnError>): RequestResult<PatchPlantPhotoResponses, PatchPlantPhotoErrors, ThrowOnError> => (options.client ?? client).patch<PatchPlantPhotoResponses, PatchPlantPhotoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-photos/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a PlantPhoto (idempotent)
 */
export const putPlantPhoto = <ThrowOnError extends boolean = false>(options: Options<PutPlantPhotoData, ThrowOnError>): RequestResult<PutPlantPhotoResponses, PutPlantPhotoErrors, ThrowOnError> => (options.client ?? client).put<PutPlantPhotoResponses, PutPlantPhotoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plant-photos/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Plant rows (delta sync)
 */
export const listPlants = <ThrowOnError extends boolean = false>(options?: Options<ListPlantsData, ThrowOnError>): RequestResult<ListPlantsResponses, ListPlantsErrors, ThrowOnError> => (options?.client ?? client).get<ListPlantsResponses, ListPlantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plants',
    ...options
});

/**
 * Delete a Plant (soft by default)
 */
export const deletePlant = <ThrowOnError extends boolean = false>(options: Options<DeletePlantData, ThrowOnError>): RequestResult<DeletePlantResponses, DeletePlantErrors, ThrowOnError> => (options.client ?? client).delete<DeletePlantResponses, DeletePlantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plants/{id}',
    ...options
});

/**
 * Get one Plant
 */
export const getPlant = <ThrowOnError extends boolean = false>(options: Options<GetPlantData, ThrowOnError>): RequestResult<GetPlantResponses, GetPlantErrors, ThrowOnError> => (options.client ?? client).get<GetPlantResponses, GetPlantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plants/{id}',
    ...options
});

/**
 * Update fields of a Plant
 */
export const patchPlant = <ThrowOnError extends boolean = false>(options: Options<PatchPlantData, ThrowOnError>): RequestResult<PatchPlantResponses, PatchPlantErrors, ThrowOnError> => (options.client ?? client).patch<PatchPlantResponses, PatchPlantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a Plant (idempotent)
 */
export const putPlant = <ThrowOnError extends boolean = false>(options: Options<PutPlantData, ThrowOnError>): RequestResult<PutPlantResponses, PutPlantErrors, ThrowOnError> => (options.client ?? client).put<PutPlantResponses, PutPlantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A shared collection and its plants (public)
 */
export const getSharedCollection = <ThrowOnError extends boolean = false>(options: Options<GetSharedCollectionData, ThrowOnError>): RequestResult<GetSharedCollectionResponses, GetSharedCollectionErrors, ThrowOnError> => (options.client ?? client).get<GetSharedCollectionResponses, GetSharedCollectionErrors, ThrowOnError>({ url: '/v1/shared-collections/{token}', ...options });

/**
 * Add an unverified plant name to the shared database
 */
export const contributeTaxon = <ThrowOnError extends boolean = false>(options: Options<ContributeTaxonData, ThrowOnError>): RequestResult<ContributeTaxonResponses, ContributeTaxonErrors, ThrowOnError> => (options.client ?? client).post<ContributeTaxonResponses, ContributeTaxonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/taxa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search the botanical database (public)
 */
export const searchTaxa = <ThrowOnError extends boolean = false>(options: Options<SearchTaxaData, ThrowOnError>): RequestResult<SearchTaxaResponses, SearchTaxaErrors, ThrowOnError> => (options.client ?? client).get<SearchTaxaResponses, SearchTaxaErrors, ThrowOnError>({ url: '/v1/taxa/search', ...options });

/**
 * Ancestors of a taxon, broadest rank first (public)
 */
export const getTaxonLineage = <ThrowOnError extends boolean = false>(options: Options<GetTaxonLineageData, ThrowOnError>): RequestResult<GetTaxonLineageResponses, GetTaxonLineageErrors, ThrowOnError> => (options.client ?? client).get<GetTaxonLineageResponses, GetTaxonLineageErrors, ThrowOnError>({ url: '/v1/taxa/{id}/lineage', ...options });

/**
 * List my tickets
 */
export const listTickets = <ThrowOnError extends boolean = false>(options?: Options<ListTicketsData, ThrowOnError>): RequestResult<ListTicketsResponses, ListTicketsErrors, ThrowOnError> => (options?.client ?? client).get<ListTicketsResponses, ListTicketsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options
});

/**
 * Open a ticket
 */
export const createTicket = <ThrowOnError extends boolean = false>(options: Options<CreateTicketData, ThrowOnError>): RequestResult<CreateTicketResponses, CreateTicketErrors, ThrowOnError> => (options.client ?? client).post<CreateTicketResponses, CreateTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One of my tickets with its conversation
 */
export const getTicket = <ThrowOnError extends boolean = false>(options: Options<GetTicketData, ThrowOnError>): RequestResult<GetTicketResponses, GetTicketErrors, ThrowOnError> => (options.client ?? client).get<GetTicketResponses, GetTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}',
    ...options
});

/**
 * Add a note to a ticket
 */
export const addTicketMessage = <ThrowOnError extends boolean = false>(options: Options<AddTicketMessageData, ThrowOnError>): RequestResult<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError> => (options.client ?? client).post<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close or reopen a ticket
 */
export const setTicketStatus = <ThrowOnError extends boolean = false>(options: Options<SetTicketStatusData, ThrowOnError>): RequestResult<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError> => (options.client ?? client).post<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an uploaded file
 */
export const deleteUpload = <ThrowOnError extends boolean = false>(options: Options<DeleteUploadData, ThrowOnError>): RequestResult<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/uploads',
    ...options
});

/**
 * A short-lived signed URL for an uploaded file
 */
export const getUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GetUploadUrlData, ThrowOnError>): RequestResult<GetUploadUrlResponses, GetUploadUrlErrors, ThrowOnError> => (options.client ?? client).get<GetUploadUrlResponses, GetUploadUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/uploads/url',
    ...options
});

/**
 * RevenueCat server-to-server event
 */
export const revenueCatWebhook = <ThrowOnError extends boolean = false>(options: Options<RevenueCatWebhookData, ThrowOnError>): RequestResult<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError> => (options.client ?? client).post<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError>({
    url: '/v1/webhooks/revenuecat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
